import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import LaundriesTable from "components/Doobi/Laundries";
import LaundryUsersTable from "components/Doobi/LaundryUsers";
import LaundrySlotsTable from "components/Doobi/LaundrySlots";

const LaundriesRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Laundries" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/slots/:id`} component={LaundrySlotsTable}/>
      <Route path={`${match.path}/:id`} component={LaundryUsersTable}/>
      <Route path={`${match.path}/`} component={LaundriesTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default LaundriesRoute;
